//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminDocumentController_findAll,
  Response$AdminDocumentController_findAll$Status$200,
  ResponseContentType$AdminDocumentController_findAll,
} from '@api-client/generated/client';
import { QueryOptions, useApiClient } from '@hooks/useApiClient';

export const useAdminDocumentController_findAll = (options: {
  params: Params$AdminDocumentController_findAll['parameter'];
  config?: QueryOptions<
    Response$AdminDocumentController_findAll$Status$200[ResponseContentType$AdminDocumentController_findAll]
  >;
}) =>
  useApiClient<
    Params$AdminDocumentController_findAll,
    Response$AdminDocumentController_findAll$Status$200[ResponseContentType$AdminDocumentController_findAll]
  >({
    method: 'AdminDocumentController_findAll',
    params: { parameter: options.params },
    config: options.config,
  });
